import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";
import {
  Button,
  Progress,
  Modal,
  ModalBody,
  ModalFooter,
  Col,
  Row,
  Container,
  ModalHeader,
  FormGroup,
  Input,
  Label,
  UncontrolledTooltip
} from "reactstrap";
import HttpUtil from "../../Util/httpUtil";
import Config from "../../Util/config";
import PrettyCheckbox from "../Common/PrettyCheckbox";
import { formataData, validarCNPJ, formataCurrency } from "../../BaseFunctions";
import TooltippedCel from "../Common/TooltippedCel";
import InputMask from "react-input-mask";
import "./RemessaBancaria.scss";
import { ModalAvisoContext } from "../../Context/ModalAvisoContext";

class RemessaBancaria extends Component {
  static contextType = ModalAvisoContext;
  constructor(props) {
    super(props);

    this.defaultState = {
      isOpen: false,
      loading: false,
      banco: 0,
      listaBancos: [],
      dropDownOpen: "",
      showTabela: false,
      isError: false,
      listaSelecionada: [],
      listaDisponibilidade: [],
      flagUsarCnpjInformado: false,
      cnpjInformado: "",
      invalido: {
        cnpjInformado: false
      },
      itau: {
        agencia: "",
        conta: "",
        digitoConta: ""
      },
      bb: {
        numeroDoConvenio: "",
        numeroDoMci: "",
        autorizacaoDeDebito: ""
      },
      bd: {
        numeroDoConvenio: "",
        agencia: "",
        digitoAgencia: "",
        conta: "",
        digitoConta: ""
      },
      santander: {
        numeroDoConvenio: "",
        agencia: "",
        digitoAgencia: "",
        conta: "",
        digitoConta: ""
      },
      completamentePreenchido: false,
      columns: [
        {
          accessor: "blSelected",
          Cell: row => (
            <PrettyCheckbox
              strTitle="Selecionar"
              checked={row.original.blSelected}
              id="blSelected"
              onChange={() => this.handleTableSelectChange(row)}
              iconSuccess="fas fa-check"
              simpleSelection
            />
          ),
          filterable: false,
          sortable: false,
          className: "text-center align-center",
          width: 35
        },
        {
          Header: () => <div className="text-left">Emitente</div>,
          accessor: "emitente",
          className: "text-left",
          Cell: row => this.mostrarDestacados(row, row.value, false)
        },
        {
          Header: "Pagamento",
          accessor: "pagamento",
          className: "text-center",
          Cell: row => this.mostrarDestacados(row, row.value, false),
          width: 115
        },
        {
          Header: "UF DESTINO",
          accessor: "uf",
          className: "text-center",
          Cell: row => this.mostrarDestacados(row, row.value, false),
          width: 100
        },
        {
          Header: "Valor",
          accessor: "valor",
          className: "text-center",
          width: 100,
          Cell: row => this.mostrarDestacados(row, formataCurrency(row.value))
        }
      ]
    };
    this.state = {
      ...this.defaultState
    };

    this.mapBancos = {
      ITAU: 1,
      "BANCO DO BRASIL": 2,
      SANTANDER: 3,
      BRADESCO: 4
    };

    this.reactTable = React.createRef({
      pagination: {
        pageSize: 3
      }
    });
  }

  toggleModal = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  openModal = async () => {
    const res = await HttpUtil.eco_GET(
      `${Config.urls.API_URL_BASE}Documento/BuscarBancos`
    );
    console.log(res.data);
    this.setState({
      listaBancos: res.data
    });

    this.setState({ isOpen: true });
  };

  closeModal = () => {
    this.setState({
      ...this.defaultState
    });
  };

  checarNumeroSequencial() {
    try {
      HttpUtil.eco_POST(
        `${
          Config.urls.API_URL_BASE
        }Documento/RemessaBancaria/BuscarNumneroSequencialArquivo`,
        {
          idUsuario: +localStorage.getItem("CodUsuario"),
          idBanco: this.mapBancos["BRADESCO"]
        }
      ).then(res => {
        if (res.data == "999999") {
          this.handleOpenModalAviso();
          return;
        }
        this.enviarPayload();
      });
    } catch (error) {
      console.log(error);
    }
  }

  gerarArquivo = () => {
    if (this.state.banco == this.mapBancos["BRADESCO"]) {
      this.checarNumeroSequencial();
      return;
    }
    this.enviarPayload();
  };

  enviarPayload = () => {
    let listaFormatada = [];
    this.state.listaDisponibilidade.forEach(item => {
      listaFormatada.push({
        idDocumento: item.idDocumento,
        uf: item.uf
      });
    });
    const bancoSelecionado = this.state.listaBancos.find(
      i => i.id == this.state.banco
    );
    const payload = {
      idUsuario: localStorage.getItem("CodUsuario"),
      lstDocumentosUfs: listaFormatada,
      idBanco: this.state.banco,
      banco: bancoSelecionado.descricao.replace(" ", ""),
      flagUsarCnpjInformado: this.state.flagUsarCnpjInformado
    };

    if (this.state.banco == this.mapBancos["ITAU"]) {
      payload.agencia = this.state.itau.agencia;
      payload.conta = this.state.itau.conta;
      payload.dv = this.state.itau.digitoConta;
    }

    if (this.state.banco == this.mapBancos["BANCO DO BRASIL"]) {
      payload.autorizacaoDeDebito = this.state.bb.autorizacaoDeDebito;
      payload.numeroDoConvenio = this.state.bb.numeroDoConvenio;
      payload.numeroDoMci = this.state.bb.numeroDoMci;
    }

    if (this.state.banco == this.mapBancos["BRADESCO"]) {
      payload.agencia = this.state.bd.agencia;
      payload.dvAgencia = this.state.bd.digitoAgencia;
      payload.conta = this.state.bd.conta;
      payload.dv = this.state.bd.digitoConta;
      payload.numeroDoConvenio = this.state.bd.numeroDoConvenio;
    }

    if (this.state.banco == this.mapBancos["SANTANDER"]) {
      payload.agencia = this.state.santander.agencia;
      payload.dvAgencia = this.state.santander.digitoAgencia;
      payload.conta = this.state.santander.conta;
      payload.dv = this.state.santander.digitoConta;
      payload.numeroDoConvenio = this.state.santander.numeroDoConvenio;
    }

    if (this.state.flagUsarCnpjInformado) {
      const cnpjValido =
        validarCNPJ(this.state.cnpjInformado) &&
        this.state.cnpjInformado.length == 18;
      if (!cnpjValido) {
        this.setState({
          invalido: {
            ...this.state.invalido,
            cnpjInformado: true
          }
        });
        return;
      }
      this.setState({
        invalido: {
          ...this.state.invalido,
          cnpjInformado: false
        }
      });
      payload.cnpjInformado = this.state.cnpjInformado.replace(/\D/g, "");
    }
    HttpUtil.eco_POST(
      `${Config.urls.API_URL_BASE}Documento/RemessaBancaria`,
      payload
    )
      .then(response => {
        const data = response.data;
        this.gerarArquivoTXT(data, bancoSelecionado.descricao.replace(" ", ""));
        // Resetar dados da conta e fechar modal
        this.setState({
          ...this.defaultState
        });
      })
      .catch(error => console.error(error));
  };

  gerarArquivoTXT = (data, banco) => {
    const blob = new Blob([data], { type: "text/plain;charset=utf-8" });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    const nomeArquivo = `ArquivoRemessa_${banco}_${this.obterDataHoraAtual()}.txt`;

    link.download = nomeArquivo;
    document.body.appendChild(link);

    link.click();
    document.body.removeChild(link);
  };

  obterDataHoraAtual = () => {
    const now = new Date();

    const ano = now.getFullYear();
    const mes = String(now.getMonth() + 1).padStart(2, "0");
    const dia = String(now.getDate()).padStart(2, "0");
    const horas = String(now.getHours()).padStart(2, "0");
    const minutos = String(now.getMinutes()).padStart(2, "0");
    const segundos = String(now.getSeconds()).padStart(2, "0");

    return `${ano}-${mes}-${dia}_${horas}-${minutos}-${segundos}`;
  };

  toggle = () => {
    this.setState({
      dropDownOpen: !this.state.dropDownOpen
    });
  };

  handleChangeBanco = async id => {
    this.setState({
      banco: id,
      contaModel: "",
      cnpjInformado: "",
      flagUsarCnpjInformado: false,
      completamentePreenchido: false,
      bb: {
        autorizacaoDeDebito: "",
        numeroDoConvenio: "",
        numeroDoMci: ""
      }
    });
    if (id == "") return;
    setTimeout(() => {
      this.selecionarBanco();
    }, 100);
  };

  selecionarBanco = async () => {
    if (!this.props.value || !Array.isArray(this.props.value)) {
      return;
    }
    this.setState({ loading: true, showTabela: true });
    let listaFormatada = [];
    this.props.value.forEach(item => {
      listaFormatada.push({
        idBanco: this.state.banco,
        idDocumento: Math.abs(item.id),
        emitente: item.razaoSocialEmissor,
        pagamento: formataData(item.data),
        uf: item.uf,
        valor: item.valor
      });
    });

    this.verificarDisponibilidade(listaFormatada);
  };

  verificarDisponibilidade = lista => {
    HttpUtil.eco_POST(
      `${
        Config.urls.API_URL_BASE
      }Documento/RemessaBancaria/VerificarDisponibilidade`,
      lista
    ).then(res => {
      this.setState({
        listaDisponibilidade: res.data,
        loading: false
      });

      const hasError = res.data.some(item => !item.disponibilidade);
      if (hasError) {
        this.setState({ isError: true });
        return;
      }
      this.setState({ isError: false });
    });
  };

  handleTableSelectAll = () => {
    if (this.state.listaSelecionada.length === 0) {
      this.setState({ listaSelecionada: this.state.listaDisponibilidade });
    } else {
      this.setState({ listaSelecionada: [] });
    }
  };

  handleTableSelectChange = row => {
    const lista = this.state.listaSelecionada;
    const indice = lista.findIndex(
      item => item.idDocumento === row.original.idDocumento
    );

    if (indice === -1) {
      lista.push(row.original);
    } else {
      lista.splice(indice, 1);
    }

    this.setState({ listaSelecionada: lista });
  };

  mostrarDestacados = (row, valor, tooltip = false) => {
    return (
      <div
        className={`row-mostrar-destacados ${
          row.original.disponibilidade ? "" : "linha-error"
        }`}
      >
        {tooltip ? <TooltippedCel text={valor} /> : valor}
      </div>
    );
  };

  obterMotivosIndisponibilidade = () => {
    const motivos = new Set(
      (this.state.listaDisponibilidade || [])
        .filter(item => !item.disponibilidade)
        .map(item => item.motivoIndisponibilidade)
    );
    return {
      ufNaoAceita: motivos.has("UF_NAO_ACEITA"),
      semCodigoBarras: motivos.has("SEM_CODIGO_BARRAS")
    };
  };

  textFilterMethod = (filter, row) =>
    row[filter.id] &&
    row[filter.id].toLowerCase().indexOf(filter.value.toLowerCase()) > -1;

  dateFilterMethod = (filter, row) =>
    row[filter.id] &&
    new Date(row[filter.id]).toLocaleDateString().indexOf(filter.value) > -1;

  textFilterSituacao = (filter, row) => {
    if (filter.value.toLowerCase() == "impresso") {
      return (
        row[filter.id] &&
        row[filter.id].toLowerCase().indexOf(filter.value.toLowerCase()) > -1
      );
    }
    if (filter.value.toLowerCase() == "não impresso") {
      let teste = "Sucesso";
      return (
        row[filter.id] &&
        row[filter.id].toLowerCase().indexOf(teste.toLowerCase()) > -1
      );
    }
  };

  handleChangeItau = (value, tipo) => {
    switch (tipo) {
      case "agência":
        value = value.replace(/\D/g, "").substr(0, 5);
        this.setState(prev => ({
          ...prev,
          itau: {
            ...prev.itau,
            agencia: value
          }
        }));
        break;
      case "conta":
        value = value.replace(/\D/g, "").substr(0, 12);
        this.setState(prev => ({
          ...prev,
          itau: {
            ...prev.itau,
            conta: value
          }
        }));

        break;
      case "dígito":
        value = value.replace(/\D/g, "").substr(0, 1);
        this.setState(prev => ({
          ...prev,
          itau: {
            ...prev.itau,
            digitoConta: value
          }
        }));
        break;
      case "cnpj":
        if (value.length < 18) {
          this.setState(previousState => ({
            ...previousState,
            invalido: {
              ...previousState.invalido,
              cnpjInformado: false
            }
          }));
        }
        this.setState({ cnpjInformado: value });
        break;
    }
    this.verificarCamposPreenchidos();
  };

  handleChangeBB = async (value, tipo) => {
    switch (tipo) {
      case "numeroDoConvenio":
        value = value.replace(/\D/g, "").substr(0, 6);
        this.setState(previousState => ({
          ...previousState,
          bb: {
            ...previousState.bb,
            numeroDoConvenio: value
          }
        }));
        break;
      case "numeroDoMci":
        value = value.replace(/\D/g, "").substr(0, 9);
        this.setState(previousState => ({
          ...previousState,
          bb: {
            ...previousState.bb,
            numeroDoMci: value
          }
        }));
        break;
      case "autorizacaoDeDebito":
        value = value.replace(/[^0-9A-Za-z]/g, "").substring(0, 25);
        this.setState(previousState => ({
          ...previousState,
          bb: {
            ...previousState.bb,
            autorizacaoDeDebito: value
          }
        }));
        break;
    }
    this.verificarCamposPreenchidos();
  };

  handleChangeBD = async (value, tipo) => {
    switch (tipo) {
      case "numeroDoConvenio":
        value = value.replace(/\D/g, "").substr(0, 20);
        this.setState(previousState => ({
          ...previousState,
          bd: {
            ...previousState.bd,
            numeroDoConvenio: value
          }
        }));
        break;
      case "agência":
        value = value.replace(/\D/g, "").substr(0, 5);
        this.setState(previousState => ({
          ...previousState,
          bd: {
            ...previousState.bd,
            agencia: value
          }
        }));
        break;
      case "dígitoAgência":
        value = value
          .replace(/[^a-zA-Z0-9]/g, "")
          .substr(0, 1)
          .toUpperCase();
        this.setState(previousState => ({
          ...previousState,
          bd: {
            ...previousState.bd,
            digitoAgencia: value
          }
        }));
        break;
      case "conta":
        value = value.replace(/\D/g, "").substr(0, 12);
        this.setState(previousState => ({
          ...previousState,
          bd: {
            ...previousState.bd,
            conta: value
          }
        }));
        break;
      case "dígitoConta":
        value = value
          .replace(/[^a-zA-Z0-9]/g, "")
          .substr(0, 2)
          .toUpperCase();
        this.setState(previousState => ({
          ...previousState,
          bd: {
            ...previousState.bd,
            digitoConta: value
          }
        }));
        break;
    }
    this.verificarCamposPreenchidos();
  };

  handleChangeSantander = async (value, tipo) => {
    switch (tipo) {
      case "numeroDoConvenio":
        value = value.replace(/\D/g, "").substr(0, 12);
        this.setState(previousState => ({
          ...previousState,
          santander: {
            ...previousState.santander,
            numeroDoConvenio: value
          }
        }));
        break;
      case "agência":
        value = value.replace(/\D/g, "").substr(0, 4);
        this.setState(previousState => ({
          ...previousState,
          santander: {
            ...previousState.santander,
            agencia: value
          }
        }));
        break;
      case "dígitoAgência":
        value = value
          .replace(/[^a-zA-Z0-9]/g, "")
          .substr(0, 1)
          .toUpperCase();
        this.setState(previousState => ({
          ...previousState,
          santander: {
            ...previousState.santander,
            digitoAgencia: value
          }
        }));
        break;
      case "conta":
        value = value.replace(/\D/g, "").substr(0, 12);
        this.setState(previousState => ({
          ...previousState,
          santander: {
            ...previousState.santander,
            conta: value
          }
        }));
        break;
      case "dígitoConta":
        value = value
          .replace(/[^a-zA-Z0-9]/g, "")
          .substr(0, 1)
          .toUpperCase();
        this.setState(previousState => ({
          ...previousState,
          santander: {
            ...previousState.santander,
            digitoConta: value
          }
        }));
        break;
    }
    this.verificarCamposPreenchidos();
  };

  handleUsarCNPJChange(checked) {
    this.setState({ flagUsarCnpjInformado: checked, cnpjInformado: "" });
    this.verificarCamposPreenchidos();
  }

  handleOpenModalAviso = () => {
    const { openModal, setMessage, setCloseCallback } = this.context;
    setCloseCallback(() => {
      setMessage(<></>);
      this.enviarPayload();
    });
    setMessage(
      <p>
        Por reiniciar a contagem sequencial do arquivo (999999 / 000001), antes
        de enviar este arquivo ao banco para pagamento, favor entrar em contato
        com a <strong>Central de Remessa do Banco Bradesco</strong>, através do
        número <strong>3003-1000, opção 4</strong>, para que o banco zere e
        recomece a contagem do sequencial.
      </p>
    );
    openModal();
  };

  verificarCamposPreenchidos() {
    if (this.state.banco == this.mapBancos["ITAU"]) {
      setTimeout(() => {
        const camposPreenchidos = [
          this.state.itau.agencia.length > 0,
          this.state.itau.conta.length > 0,
          this.state.itau.digitoConta.length > 0
        ];

        if (this.state.flagUsarCnpjInformado) {
          camposPreenchidos.push(
            this.state.cnpjInformado.replace(/\D/g, "").length === 14
          );
        }
        this.setState(previousState => ({
          ...previousState,
          completamentePreenchido: camposPreenchidos.every(Boolean)
        }));
      }, 100);
    }
    if (this.state.banco == this.mapBancos["BANCO DO BRASIL"]) {
      setTimeout(() => {
        const camposPreenchidos = [
          this.state.bb.autorizacaoDeDebito.length > 0,
          this.state.bb.numeroDoConvenio.length > 0,
          this.state.bb.numeroDoMci.length > 0
        ];
        this.setState(previousState => ({
          ...previousState,
          completamentePreenchido: camposPreenchidos.every(Boolean)
        }));
      }, 100);
    }
    if (this.state.banco == this.mapBancos["BRADESCO"]) {
      setTimeout(() => {
        const camposPreenchidos = [
          this.state.bd.agencia.length > 0,
          this.state.bd.conta.length > 0,
          this.state.bd.digitoConta.length > 0,
          this.state.bd.numeroDoConvenio.length > 0
        ];
        this.setState(previousState => ({
          ...previousState,
          completamentePreenchido: camposPreenchidos.every(Boolean)
        }));
      }, 100);
    }
    if (this.state.banco == this.mapBancos["SANTANDER"]) {
      setTimeout(() => {
        const camposPreenchidos = [
          this.state.santander.agencia.length > 0,
          this.state.santander.conta.length > 0,
          this.state.santander.digitoConta.length > 0,
          this.state.santander.numeroDoConvenio.length > 0
        ];
        this.setState(previousState => ({
          ...previousState,
          completamentePreenchido: camposPreenchidos.every(Boolean)
        }));
      }, 100);
    }
  }

  excluirGuias = () => {
    this.setState({ loading: true });

    const idsLista = new Set(
      this.state.listaSelecionada.map(item => item.idDocumento)
    );

    const novaLista = this.state.listaDisponibilidade.filter(
      item => !idsLista.has(item.idDocumento)
    );

    let listaFormatada = [];
    novaLista.forEach(item => {
      listaFormatada.push({
        idBanco: this.state.banco,
        idDocumento: item.idDocumento,
        emitente: item.emitente,
        pagamento: item.pagamento,
        uf: item.uf,
        valor: item.valor
      });
    });
    this.verificarDisponibilidade(listaFormatada);
    this.verificarCamposPreenchidos();
  };

  filterInput = event => {
    if (event) {
      let keyCode = "which" in event ? event.which : event.keyCode;

      let isNotWanted = keyCode == 69 || keyCode == 101;
      return !isNotWanted;
    }
    return null;
  };

  componentDidUpdate(_, prevState) {
    if (prevState.banco !== this.state.banco && this.state.banco == "") {
      this.setState({ showTabela: false });
    }
  }

  render() {
    return (
      <main id="remessa">
        <Modal
          centered={true}
          isOpen={this.state.isOpen}
          onClosed={this.props.onClosed}
          backdrop="static"
          size="xl"
        >
          <ModalHeader style={{ background: "#31597B", color: "#FFF" }}>
            Gerar Remessa Bancária{" "}
            <span style={{ fontSize: "12px" }}> v.0.2</span>
          </ModalHeader>
          <ModalBody>
            <div>
              <FormGroup>
                <Row>
                  <Col>
                    <Label style={{ fontWeight: "700" }}>Banco</Label>
                    <Input
                      type="select"
                      placeholder="Selecione um banco"
                      value={this.state.banco}
                      onChange={e => this.handleChangeBanco(e.target.value)}
                    >
                      <option value="">Selecione um banco</option>
                      {this.state.listaBancos.map((item, i) => {
                        if (item.ativo) {
                          return (
                            <option key={item.id} value={item.id}>
                              {item.descricao}
                            </option>
                          );
                        }
                      })}
                    </Input>
                  </Col>
                </Row>
              </FormGroup>
              {this.state.showTabela ? (
                <div>
                  {!this.state.loading ? (
                    <div>
                      <Col className="inputs">
                        {this.state.banco == this.mapBancos["ITAU"] && (
                          <Row cols="4" className="hasFormField">
                            <div className="formField">
                              <Label style={{ fontWeight: "700" }}>
                                Agência
                              </Label>
                              <Input
                                value={this.state.itau.agencia}
                                onChange={e =>
                                  this.handleChangeItau(
                                    e.target.value,
                                    "agência"
                                  )
                                }
                                maxLength="5"
                                type="text"
                                placeholder="Ex: 12345"
                              />
                            </div>
                            <div className="formField">
                              <Label style={{ fontWeight: "700" }}>Conta</Label>
                              <Input
                                value={this.state.itau.conta}
                                onChange={x =>
                                  this.handleChangeItau(x.target.value, "conta")
                                }
                                type="text"
                                placeholder="Ex: 56789"
                              />
                            </div>
                            <div className="formField formField--small">
                              <Label style={{ fontWeight: "700" }}>
                                Dígito
                              </Label>
                              <Input
                                value={this.state.itau.digitoConta}
                                onChange={e =>
                                  this.handleChangeItau(
                                    e.target.value,
                                    "dígito"
                                  )
                                }
                                type="text"
                                placeholder="Ex: 0"
                              />
                            </div>
                            <div className="formField">
                              <Label
                                style={{
                                  fontWeight: "700",
                                  fontSize: 10,
                                  marginLeft: "1.25rem"
                                }}
                              >
                                <div className="d-flex align-items-center">
                                  <Input
                                    type="checkbox"
                                    name="usarCNPJ"
                                    id="usarCNPJ"
                                    checked={this.state.flagUsarCnpjInformado}
                                    onChange={e =>
                                      this.handleUsarCNPJChange(
                                        e.target.checked
                                      )
                                    }
                                  />
                                  Utilizar CNPJ para pagamento diferente do
                                  emitente da nota fiscal?
                                </div>
                              </Label>
                              {this.state.flagUsarCnpjInformado && (
                                <>
                                  <InputMask
                                    type="text"
                                    placeholder="CNPJ"
                                    name="cnpj"
                                    id="cnpj"
                                    mask="99.999.999/9999-99"
                                    pattern="[0-9]{2}\.[0-9]{3}\.[0-9]{3}\/[0-9]{4}-[0-9]{2}"
                                    value={this.state.cnpjInformado}
                                    onChange={e =>
                                      this.handleChangeItau(
                                        e.target.value,
                                        "cnpj"
                                      )
                                    }
                                    className={`${
                                      this.state.invalido.cnpjInformado
                                        ? "input-error"
                                        : ""
                                    } form-control`}
                                    autoFocus={true}
                                  />
                                  {this.state.invalido.cnpjInformado && (
                                    <p className="text-error">
                                      Por favor digite um CNPJ válido
                                    </p>
                                  )}
                                </>
                              )}
                            </div>
                          </Row>
                        )}
                        {this.state.banco ==
                          this.mapBancos["BANCO DO BRASIL"] && (
                          <Row cols="4" className="hasFormField">
                            <div className="formField formField--fit">
                              <Label style={{ fontWeight: "700" }}>
                                Número do Convênio
                                <i
                                  id="nConvenio"
                                  className="fas fa-info-circle ml-1 text-primary"
                                />
                                <UncontrolledTooltip
                                  placement="right"
                                  target="nConvenio"
                                >
                                  Código numérico e único que identifica o
                                  contrato estabelecido entre o cliente e o
                                  Banco do Brasil para a prestação de serviços
                                  de cobrança
                                </UncontrolledTooltip>
                              </Label>
                              <Input
                                value={this.state.bb.numeroDoConvenio}
                                onChange={e =>
                                  this.handleChangeBB(
                                    e.target.value,
                                    "numeroDoConvenio"
                                  )
                                }
                                type="text"
                                placeholder="Ex: 123456"
                              />
                            </div>
                            <div className="formField formField--fit">
                              <Label style={{ fontWeight: "700" }}>
                                Número do MCI
                                <i
                                  id="nMci"
                                  className="fas fa-info-circle ml-1 text-primary"
                                />
                                <UncontrolledTooltip
                                  placement="right"
                                  target="nMci"
                                >
                                  Código numérico que contêm informações
                                  específicas sobre cada transação, estando
                                  relacionado ao convênio. Este código
                                  especifica o tipo de cobrança a ser realizada.
                                </UncontrolledTooltip>
                              </Label>
                              <Input
                                value={this.state.bb.numeroDoMci}
                                onChange={e =>
                                  this.handleChangeBB(
                                    e.target.value,
                                    "numeroDoMci"
                                  )
                                }
                                type="text"
                                placeholder="Ex: 123456789"
                              />
                            </div>
                            <div className="formField formField--fit" style={{width:"80%"}}>
                              <Label style={{ fontWeight: "700" }}>
                                Autorização de Débito
                                <i
                                  id="autorizacaoDebito"
                                  className="fas fa-info-circle ml-1 text-primary"
                                />
                                <UncontrolledTooltip
                                  placement="right"
                                  target="autorizacaoDebito"
                                >
                                  Código alfanumérico que significa a permissão
                                  formal que o cliente concede ao Banco do
                                  Brasil para que este possa debitar valores
                                  diretamente em sua conta corrente.
                                </UncontrolledTooltip>
                              </Label>
                              <Input
                                value={this.state.bb.autorizacaoDeDebito}
                                onChange={e =>
                                  this.handleChangeBB(
                                    e.target.value,
                                    "autorizacaoDeDebito"
                                  )
                                }
                                type="text"
                                placeholder="Ex: 123456"
                              />
                            </div>
                            <div className="formField">
                              <Label
                                style={{
                                  fontWeight: "700",
                                  fontSize: 10,
                                  marginLeft: "1.25rem"
                                }}
                              >
                                <div className="d-flex align-items-center">
                                  <Input
                                    type="checkbox"
                                    name="usarCNPJ"
                                    id="usarCNPJ"
                                    checked={this.state.flagUsarCnpjInformado}
                                    onChange={e =>
                                      this.handleUsarCNPJChange(
                                        e.target.checked
                                      )
                                    }
                                  />
                                  Utilizar CNPJ para pagamento diferente do
                                  emitente da nota fiscal?
                                </div>
                              </Label>
                              {this.state.flagUsarCnpjInformado && (
                                <>
                                  <InputMask
                                    type="text"
                                    placeholder="CNPJ"
                                    name="cnpj"
                                    id="cnpj"
                                    mask="99.999.999/9999-99"
                                    pattern="[0-9]{2}\.[0-9]{3}\.[0-9]{3}\/[0-9]{4}-[0-9]{2}"
                                    value={this.state.cnpjInformado}
                                    onChange={e =>
                                      this.handleChangeItau(
                                        e.target.value,
                                        "cnpj"
                                      )
                                    }
                                    className={`${
                                      this.state.invalido.cnpjInformado
                                        ? "input-error"
                                        : ""
                                    } form-control`}
                                    autoFocus={true}
                                  />
                                  {this.state.invalido.cnpjInformado && (
                                    <p className="text-error">
                                      Por favor digite um CNPJ válido
                                    </p>
                                  )}
                                </>
                              )}
                            </div>
                          </Row>
                        )}
                        {this.state.banco == this.mapBancos["BRADESCO"] && (
                          <Row cols="4" className="hasFormField">
                            <div className="formField formField--fit">
                              <Label style={{ fontWeight: "700" }}>
                                Número do Convênio
                                <i
                                  id="nConvenio"
                                  className="fas fa-info-circle ml-1 text-primary"
                                />
                                <UncontrolledTooltip
                                  placement="right"
                                  target="nConvenio"
                                >
                                  Código adotado pelo banco para identificar o
                                  contrato entre este e a empresa cliente.
                                </UncontrolledTooltip>
                              </Label>
                              <Input
                                value={this.state.bd.numeroDoConvenio}
                                onChange={e =>
                                  this.handleChangeBD(
                                    e.target.value,
                                    "numeroDoConvenio"
                                  )
                                }
                                type="text"
                                placeholder="Ex: 123456789"
                              />
                            </div>
                            <div className="formField formField--small" style={{width:"10%"}}>
                              <Label style={{ fontWeight: "700" }}>
                                Agência
                              </Label>
                              <Input
                                value={this.state.bd.agencia}
                                onChange={e =>
                                  this.handleChangeBD(e.target.value, "agência")
                                }
                                maxLength="5"
                                type="text"
                                placeholder="Ex: 12345"
                              />
                            </div>
                            <div className="formField formField--small" style={{width:"10%"}}>
                              <Label style={{ fontWeight: "700" }}>
                                Dígito Agência
                              </Label>
                              <Input
                                value={this.state.bd.digitoAgencia}
                                onChange={e =>
                                  this.handleChangeBD(
                                    e.target.value,
                                    "dígitoAgência"
                                  )
                                }
                                type="text"
                                placeholder="Ex: 0"
                              />
                            </div>
                            <div className="formField formField--small" style={{width:"15%"}}>
                              <Label style={{ fontWeight: "700" }}>Conta</Label>
                              <Input
                                value={this.state.bd.conta}
                                onChange={x =>
                                  this.handleChangeBD(x.target.value, "conta")
                                }
                                type="text"
                                placeholder="Ex: 56789"
                              />
                            </div>
                            <div className="formField formField--small" style={{width:"10%"}}>
                              <Label style={{ fontWeight: "700" }}>
                                Dígito Conta
                              </Label>
                              <Input
                                value={this.state.bd.digitoConta}
                                onChange={e =>
                                  this.handleChangeBD(
                                    e.target.value,
                                    "dígitoConta"
                                  )
                                }
                                type="text"
                                placeholder="Ex: 12"
                              />
                            </div>
                            <div className="formField formField--small">
                              <Label
                                style={{
                                  fontWeight: "700",
                                  fontSize: 10,
                                  marginLeft: "1.25rem"
                                }}
                              >
                              <div className="d-flex align-items-center">
                                <Input
                                  type="checkbox"
                                  name="usarCNPJ"
                                  id="usarCNPJ"
                                  checked={this.state.flagUsarCnpjInformado}
                                  onChange={e =>
                                    this.handleUsarCNPJChange(
                                      e.target.checked
                                    )
                                  }
                                />
                                Utilizar CNPJ para pagamento diferente do
                                emitente da nota fiscal?
                              </div>
                              </Label>
                              {this.state.flagUsarCnpjInformado && (
                                <>
                                  <InputMask
                                    type="text"
                                    placeholder="CNPJ"
                                    name="cnpj"
                                    id="cnpj"
                                    mask="99.999.999/9999-99"
                                    pattern="[0-9]{2}\.[0-9]{3}\.[0-9]{3}\/[0-9]{4}-[0-9]{2}"
                                    value={this.state.cnpjInformado}
                                    onChange={e =>
                                      this.handleChangeItau(
                                        e.target.value,
                                        "cnpj"
                                      )
                                    }
                                    className={`${
                                      this.state.invalido.cnpjInformado
                                        ? "input-error"
                                        : ""
                                    } form-control`}
                                    autoFocus={true}
                                  />
                                  {this.state.invalido.cnpjInformado && (
                                    <p className="text-error">
                                      Por favor digite um CNPJ válido
                                    </p>
                                  )}
                                </>
                              )}
                            </div>
                          </Row>
                        )}
                        {this.state.banco == this.mapBancos["SANTANDER"] && (
                          <Row cols="4" className="hasFormField">
                            <div className="formField formField--fit">
                              <Label style={{ fontWeight: "700" }}>
                                Número do Convênio
                                <i
                                  id="nConvenio"
                                  className="fas fa-info-circle ml-1 text-primary"
                                />
                                <UncontrolledTooltip
                                  placement="right"
                                  target="nConvenio"
                                >
                                  Código adotado pelo banco para identificar o
                                  contrato entre este e a empresa cliente.
                                </UncontrolledTooltip>
                              </Label>
                              <Input
                                value={this.state.santander.numeroDoConvenio}
                                onChange={e =>
                                  this.handleChangeSantander(
                                    e.target.value,
                                    "numeroDoConvenio"
                                  )
                                }
                                type="text"
                                placeholder="Ex: 123456789"
                              />
                            </div>
                            <div className="formField formField--small" style={{width:"10%"}}>
                              <Label style={{ fontWeight: "700" }}>
                                Agência
                              </Label>
                              <Input
                                value={this.state.santander.agencia}
                                onChange={e =>
                                  this.handleChangeSantander(
                                    e.target.value,
                                    "agência"
                                  )
                                }
                                maxLength="5"
                                type="text"
                                placeholder="Ex: 12345"
                              />
                            </div>
                            <div className="formField formField--small" style={{width:"10%"}}>
                              <Label style={{ fontWeight: "700" }}>
                                Dígito Agência
                              </Label>
                              <Input
                                value={this.state.santander.digitoAgencia}
                                onChange={e =>
                                  this.handleChangeSantander(
                                    e.target.value,
                                    "dígitoAgência"
                                  )
                                }
                                type="text"
                                placeholder="Ex: 0"
                              />
                            </div>
                            <div className="formField  formField--small" style={{width:"15%"}}>
                              <Label style={{ fontWeight: "700" }}>Conta</Label>
                              <Input
                                value={this.state.santander.conta}
                                onChange={x =>
                                  this.handleChangeSantander(
                                    x.target.value,
                                    "conta"
                                  )
                                }
                                type="text"
                                placeholder="Ex: 56789"
                              />
                            </div>
                            <div className="formField formField--small" style={{width:"10%"}}>
                              <Label style={{ fontWeight: "700" }}>
                                Dígito Conta
                              </Label>
                              <Input
                                value={this.state.santander.digitoConta}
                                onChange={e =>
                                  this.handleChangeSantander(
                                    e.target.value,
                                    "dígitoConta"
                                  )
                                }
                                type="text"
                                placeholder="Ex: 12"
                              />
                            </div>
                            <div className="formField formField--small">
                              <Label
                                style={{
                                  fontWeight: "700",
                                  fontSize: 10,
                                  marginLeft: "1.25rem"
                                }}
                              >
                              <div className="d-flex align-items-center">
                                <Input
                                  type="checkbox"
                                  name="usarCNPJ"
                                  id="usarCNPJ"
                                  checked={this.state.flagUsarCnpjInformado}
                                  onChange={e =>
                                    this.handleUsarCNPJChange(
                                      e.target.checked
                                    )
                                  }
                                />
                                Utilizar CNPJ para pagamento diferente do
                                emitente da nota fiscal?
                              </div>
                              </Label>
                              {this.state.flagUsarCnpjInformado && (
                                <>
                                  <InputMask
                                    type="text"
                                    placeholder="CNPJ"
                                    name="cnpj"
                                    id="cnpj"
                                    mask="99.999.999/9999-99"
                                    pattern="[0-9]{2}\.[0-9]{3}\.[0-9]{3}\/[0-9]{4}-[0-9]{2}"
                                    value={this.state.cnpjInformado}
                                    onChange={e =>
                                      this.handleChangeItau(
                                        e.target.value,
                                        "cnpj"
                                      )
                                    }
                                    className={`${
                                      this.state.invalido.cnpjInformado
                                        ? "input-error"
                                        : ""
                                    } form-control`}
                                    autoFocus={true}
                                  />
                                  {this.state.invalido.cnpjInformado && (
                                    <p className="text-error">
                                      Por favor digite um CNPJ válido
                                    </p>
                                  )}
                                </>
                              )}
                            </div>
                          </Row>
                        )}
                        {this.state.isError ? (
                          <Row className="align-center">
                            <div className="error-box">
                              <span
                                style={{
                                  fontWeight: "700",
                                  color: "#DC3545"
                                }}
                              >
                                O processo de geração da remessa bancária foi
                                interrompido.
                              </span>
                              {this.obterMotivosIndisponibilidade()
                                .ufNaoAceita && (
                                <span>
                                  Algumas unidades federativas de destino das
                                  guias selecionadas não aceitam o banco
                                  escolhido como arrecadador do imposto. Por
                                  favor, revise a seleção das guias e escolha
                                  um banco que seja aceito por todas as
                                  unidades federativas envolvidas.
                                  <a
                                    href="https://www.gnre.pe.gov.br:444/gnre/portal/bancosArrecadadores.jsp"
                                    target="_blank"
                                  >
                                    Verificar disponibilidade de remessa por UF
                                  </a>
                                  .
                                </span>
                              )}
                              {this.obterMotivosIndisponibilidade()
                                .semCodigoBarras && (
                                <span>
                                  Algumas guias selecionadas ainda não possuem
                                  código de barras retornado pela SEFAZ e por
                                  isso não podem ser incluídas na remessa. Por
                                  favor, desmarque essas guias (destacadas
                                  abaixo) e tente <strong>
                                    emitir novamente
                                  </strong>{" "}
                                  na tela de guias pendentes.
                                </span>
                              )}
                            </div>
                          </Row>
                        ) : (
                          <Row className="justify-space-between">
                            <div>
                              <h6>
                                Lista de guias relacionadas para remessa
                                bancária:
                              </h6>
                            </div>
                            <div>
                              verificar disponibilidade de{" "}
                              <a
                                href="https://www.gnre.pe.gov.br:444/gnre/portal/bancosArrecadadores.jsp"
                                target="_blank"
                              >
                                remessa por UF
                              </a>
                            </div>
                          </Row>
                        )}
                        <Row>
                          <Button
                            color="base-class btn-danger"
                            onClick={() => this.excluirGuias()}
                          >
                            <i className="fas fa-trash-alt white" />
                            Remover guia
                          </Button>
                        </Row>
                      </Col>
                      <ReactTable
                        data={this.state.listaDisponibilidade || []}
                        ref={this.reactTable}
                        columns={this.state.columns}
                        showPageSizeOptions={false}
                        showPagination={false}
                        className="table-remessa"
                        pageSize={this.state.listaDisponibilidade.length}
                      />
                    </div>
                  ) : (
                    <Progress animated value="100" />
                  )}
                </div>
              ) : null}
            </div>
          </ModalBody>
          <ModalFooter>
            <Container>
              <Row className="justify-content-end">
                <Col xs="auto">
                  <Button color="info" onClick={() => this.closeModal()}>
                    Fechar
                  </Button>
                </Col>
                <Col xs="auto">
                  <Button
                    disabled={
                      !this.state.completamentePreenchido || this.state.isError
                    }
                    color="primary"
                    onClick={() => this.gerarArquivo()}
                  >
                    Gerar Arquivo
                  </Button>
                </Col>
              </Row>
            </Container>
          </ModalFooter>
        </Modal>
      </main>
    );
  }
}

RemessaBancaria.propTypes = {
  value: PropTypes.array,
  onClosed: PropTypes.func.isRequired
};

export default RemessaBancaria;
